import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class AfterReportHandlerService {
	private handler$ = new Subject<any>();
	handler = this.handler$.asObservable();

	handleAfterReportEffect(action: any) {
		this.handler$.next(action);
	}
}
